import BankIcon from '@images/icons/create-recipient-bank.svg?react'
import CryptoIcon from '@images/icons/create-recipient-crypto.svg?react'
import { useCurrencies } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import BankRecipient from './CreateBankRecipient'
import CryptoRecipient from './CreateCryptoRecipient'
import KingdomRecipient from './CreateKingdomRecipient'
import CustomCheckbox from './CustomRecipientCheckbox'

// import KingdomIcon from '@images/icons/create-recipient-kingdom.svg?react'

type CreateRecipientProps = {
  personal?: boolean
  foreignId?: number
  currencyCode?: string
  onClose?: () => void
  onSuccess?: (recipientId: number) => void
}

const CreateRecipient = (props: CreateRecipientProps) => {
  const { personal, foreignId, currencyCode, onClose, onSuccess } = props

  const [recipientType, setRecipientType] = useState<'bank' | 'crypto' | 'kingdom'>('bank')

  const { getCurrencyType } = useCurrencies()

  const handleSuccess = (recipientId: number) => {
    typeof onSuccess === 'function' && onSuccess(recipientId)
    typeof onClose === 'function' && onClose()
  }

  useEffect(() => {
    return () => {
      setRecipientType('bank')
    }
  }, [])

  return (
    <div className='create-recipient-wrapper'>
      <div className='triple-group'>
        <CustomCheckbox
          icon={<BankIcon />}
          caption={tr('FRONTEND.RECIPIENTS.TYPE_LABEL.BANKWIRE', 'Bank recipient')}
          checked={recipientType === 'bank'}
          onClick={() => setRecipientType('bank')}
        />
        <CustomCheckbox
          icon={<CryptoIcon />}
          caption={tr('FRONTEND.RECIPIENTS.TYPE_LABEL.CRYPTO', 'Crypto recipient')}
          checked={recipientType === 'crypto'}
          disabled={getCurrencyType(currencyCode) !== 'CRYPTO'}
          onClick={() => setRecipientType('crypto')}
        />
        {/* hidden for now because we don't have KINGDOM_WALLET recipients
        <CustomCheckbox
          icon={<KingdomIcon />}
          caption={tr('FRONTEND.RECIPIENTS.TYPE_LABEL.KINGDOM', 'Kingdom recipient')}
          checked={recipientType === 'kingdom'}
          onClick={() => setRecipientType('kingdom')}
        />
        */}
      </div>

      {recipientType === 'bank' && (
        <BankRecipient
          currencyCode={currencyCode}
          foreignId={foreignId}
          personal={personal}
          onSuccess={handleSuccess}
        />
      )}
      {recipientType === 'crypto' && (
        <CryptoRecipient
          currencyCode={currencyCode}
          foreignId={foreignId}
          personal={personal}
          onClose={onClose}
          onSuccess={handleSuccess}
        />
      )}
      {recipientType === 'kingdom' && (
        <KingdomRecipient currencyCode={currencyCode} onClose={onClose} onSuccess={handleSuccess} />
      )}
    </div>
  )
}

export default CreateRecipient
